/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SimpleHorse } from '../models/SimpleHorse';
import { HttpFile } from '../http/http';

export class GroupMare {
    'mare': SimpleHorse;
    'dtArrival'?: string;
    'dtDeparture'?: string;
    'isPregnant'?: boolean;
    'dtAdded': string;
    'dtConception'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "mare",
            "baseName": "mare",
            "type": "SimpleHorse",
            "format": ""
        },
        {
            "name": "dtArrival",
            "baseName": "dtArrival",
            "type": "string",
            "format": "date"
        },
        {
            "name": "dtDeparture",
            "baseName": "dtDeparture",
            "type": "string",
            "format": "date"
        },
        {
            "name": "isPregnant",
            "baseName": "isPregnant",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "dtAdded",
            "baseName": "dtAdded",
            "type": "string",
            "format": "date"
        },
        {
            "name": "dtConception",
            "baseName": "dtConception",
            "type": "string",
            "format": "date"
        }    ];

    static getAttributeTypeMap() {
        return GroupMare.attributeTypeMap;
    }

    public constructor() {
    }
}

